require("./UI/skipWinsButton.js");
require("../../node_modules/hammerjs/hammer.min.js");
require("../../libs/reflex-library/src/lib/shape.js");
require("./pixi-spine.js");
require("../../libs/reflex-library/src/lib/gsap.min.js");
require("./LoaderController.js");
require("./game.js");
require("./helperFunctions.js");
require("./gameController.js");
require("./spinController.js");
require("./ParticleController.js");
require("./Feature/FreeSpins/freespinsController.js");
require("./Feature/Hook/hookController.js");
require("./Feature/MaxPlay/maxPlayController.js");
require("./Feature/MaxPlay/MaxPlayIntroPopup.js");
require("./Feature/Respin/RespinsPopup.js");
require("./Feature/FreeSpins/FreeSpinsSpinButtonComponent.js");
require("./Feature/FreeSpins/FreeSpinsSkipButtonComponent.js");
require("./Feature/FreeSpins/FreeSpinsDialogView.js");
require("./Feature/FreeSpins/FreeSpinsUpgradePopup.js");
require("./Feature/GambleSpin/GambleToggleView.js");
require("./GameHelpers.js");
require("../../libs/reflex-library/src/lib/screenDimObject.js");
require("../../libs/reflex-library/src/lib/screenshotAnimator.js");
require("./SymbolWinBorderAnimController.js");
require("./Feature/GambleSpin/GambleDisclaimerComponent.js");
require("./Feature/GambleSpin/GambleSpinController.js");
require("./AudioController.js");
require("./ShowReelView.js");
require("./UI/GameSlamStopButtonComponent.js");
require("./BigWinController.js");
require("../../libs/reflex-library/src/lib/colourBox.js");
require("./Feature/GambleSpin/ArrowComponent.js");
require("./UI/LuckyBetToggleController.js");
require("./UI/GambleModeButton.js");
require("./UI/MaxPlayButton.js");
require("./Feature/FreeSpins/FreeSpinsMeterComponent.js");
require("../../libs/reflex-library/src/lib/spine.js");
require("./MessagePopperView.js");
require("./UI/StakeMinusButtonComponent.js");
require("./UI/StakePlusButtonComponent.js");
require("./MessageBoxController.js");
require("./WinTextController.js");
require("./BuyBonus/BuyBonusButtonComponent.js");
require("./BuyBonus/BuyBonusPopupView.js");
require("./UI/SettingsMenuController.js");
require("./UI/SettingsMenuButtonComponent.js");
require("./Animations/BackgroundAnimsView.js");
require("./ReelSpinnerVisualSCS.js");
require("./winAnimations/movieSymbolAnimator.js");
require("./winAnimations/royalSymbolAnimator.js");
require("./winAnimations/SymbolLandAnimator.js");
require("./winlineAnimator.js");
require("./freeSpinsTrailPanel.js");
require("./animatedWindowPanel.js");
require("./risingBubbles.js");
require("./fallingSnow.js");
require("./winController.js");
require("../../libs/reflex-library/src/lib/gsapPixiPlugin.js");
require("./MotionPathPlugin.js");
require("./ScrollContainer.js");

//Setting Menu Buttons
require("./SystemSettings/SystemSettingVolumeButtonComponent.js");
require("./SystemSettings/SystemSettingsButtonComponent.js");
require("./SystemSettings/SystemSettingsCloseComponent.js");
require("./SystemSettings/SystemSettingsIntroScreenButtonComponent.js");
require("./SystemSettings/SystemSettingsSoundsComponents.js");
require("./SystemSettings/SystemSettingsBoxView.js");
require("./UI/settingSound.js");

//Stake/Bet Menu
require("./StakeSettings/stakeSelectionPopup_ext.js");

//Autoplay
require("./AutoplaySettings/autoplayManager-ext.js");

//Menubar
require("./SideMenu/SideMenuCloseComponent.js");
require("./SideMenu/SideMenuHelpComponent.js");
require("./GameRecoveryController.js");
